import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { SeoInsights } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/seo")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <SeoInsights />
    </RouteGuard>
  ),
});
